import { render, staticRenderFns } from "./FreightTableImportErrorsModal.vue?vue&type=template&id=0c5fbdb4&scoped=true"
import script from "./FreightTableImportErrorsModal.vue?vue&type=script&lang=js"
export * from "./FreightTableImportErrorsModal.vue?vue&type=script&lang=js"
import style0 from "./FreightTableImportErrorsModal.vue?vue&type=style&index=0&id=0c5fbdb4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5fbdb4",
  null
  
)

export default component.exports